import React from 'react';
import { colors } from '../constants';

const LinkedInIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.width}
    height={props.height}
    viewBox="0 0 20 20"
  >
    <path
      fill={props.color}
      d="M1.925 6.798h3.29V16.96h-3.29V6.8zM14.2 6.7c2.336 0 4.172 1.462 4.172 4.61v5.65h-3.73v-5.258c0-1.377-.582-2.317-1.865-2.317-.98 0-1.527.634-1.78 1.246-.096.22-.08.526-.08.83v5.5H7.22s.048-9.315 0-10.162h3.694v1.595c.218-.698 1.4-1.693 3.283-1.693zM3.51 2c1.212 0 1.958.76 1.982 1.762 0 .984-.77 1.764-2.006 1.764h-.024c-1.19 0-1.962-.777-1.962-1.762C1.5 2.76 2.294 2 3.51 2z"
    />
  </svg>
);

LinkedInIcon.defaultProps = {
  color: colors.mediumGrey,
};

export default LinkedInIcon;
